import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  makeStyles,
  TextField,
} from "@material-ui/core";
import Grid from "../../components/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

import { Select } from "../../components/Form";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function SaleObjFilterMiddle2({
  inquiry,
  headoffice,
  latestArray,
  latest,
  respondBuy,
  onChangeRespondBuy = () => {},
  onChangeLatest = () => {},
  typeLandArray,
  typeLandHeadofficeArray,
  typeBuildArray,
  auctionsArray,
  typeArray,
  auArray,
  onChangeTypeArray = () => {},
  onChangeAuctions = () => {},
  typeLand,
  onChangeTypeLand = () => {},
}) {
  const useStyles = makeStyles({
    DocumentContainerRow: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    DocumentContainerColumn: {
      flexDirection: "column",
    },
    DocumentContainerRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    DocumentContainerCenter: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
    DocumentContainerBetween: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
    },
  });
  const classes = useStyles();
  const [type, setType] = useState(["土地", "建物"]);
  useEffect(() => {
    onChangeTypeLand(type);
  }, [type]);
  return (
    <Box padding={1} width="100%" style={{ backgroundColor: "white" }}>
      <Grid
        container
        spacing={1}
        classes={{ root: classes.DocumentContainerColumn }}
      >
        <Grid container item spacing={1}>
          <Grid item xs={12} sm={5}>
            <Typography style={{ color: "#FF9301", fontSize: 15 }}>
              類別
            </Typography>
            <Grid
              item
              xs={6}
              sm={12}
              classes={{ root: classes.DocumentContainerRow }}
            >
              <Checkbox
                color="primary"
                checked={
                  type.length > 0 && type.length === typeLandArray.length
                }
                onChange={() => {
                  let newType = [];
                  for (let i = 0; i < typeLandArray.length; i++) {
                    newType.push(typeLandArray[i]);
                  }

                  type.length === typeLandArray.length
                    ? setType([])
                    : setType(newType);
                }}
              />
              <Typography color="primary" style={{ fontSize: 15 }}>
                全選
              </Typography>
              {typeLandArray.map((item) => (
                <>
                  <Checkbox
                    color="primary"
                    checked={Boolean(type.find((item2) => item2 === item))}
                    onChange={() => {
                      const has = type.find(
                        (selectItem) => selectItem === item
                      );
                      if (has) {
                        setType((e) => e.filter((i) => i !== item));
                      } else {
                        setType((e) => [...e, item]);
                      }
                    }}
                  />
                  <Typography color="primary" style={{ fontSize: 15 }}>
                    {item}
                  </Typography>
                </>
              ))}
              {"\u2002"}
              {type.indexOf("建物") !== -1 && type.length < 2 && (
                <Autocomplete
                  style={{ width: 200 }}
                  multiple
                  size="small"
                  limitTags={1}
                  options={
                    headoffice ? typeLandHeadofficeArray : typeBuildArray
                  }
                  disableCloseOnSelect
                  onChange={(e, value, i, j) => {
                    if (j) {
                      const hasOne = typeArray.find(
                        (item2) => item2.value === j.option.value
                      );
                      if (hasOne) {
                        if (j.option.value === "ALL") {
                          onChangeTypeArray([]);
                        } else {
                          typeArray.map((item2, index2) => {
                            if (item2.value === j.option.value) {
                              typeArray.splice(index2, 1);
                            }
                          });
                          onChangeTypeArray(typeArray);
                        }
                      } else {
                        if (j.option.value === "ALL") {
                          const newSelect = [];
                          for (
                            let i = 0;
                            i <
                            (headoffice
                              ? typeLandHeadofficeArray
                              : typeBuildArray
                            ).length;
                            i++
                          ) {
                            newSelect.push(
                              (headoffice
                                ? typeLandHeadofficeArray
                                : typeBuildArray)[i]
                            );
                          }
                          onChangeTypeArray(newSelect);
                        } else {
                          typeArray.push(j.option);
                          onChangeTypeArray(typeArray);
                        }
                      }
                    } else {
                      onChangeTypeArray([]);
                    }
                  }}
                  value={typeArray}
                  getOptionLabel={(option) => option.label}
                  getOptionSelected={(option, value) =>
                    value && option.value === value.value
                  }
                  ListboxProps={{ style: { maxHeight: "14.5rem" } }}
                  renderOption={(option) => {
                    const selectFilmIndex = typeArray.find(
                      (item) => item.value === option.value
                    );
                    return (
                      <React.Fragment>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={Boolean(selectFilmIndex)}
                        />
                        {option.label}
                      </React.Fragment>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              拍次
            </Typography>
            <Autocomplete
              fullWidth
              multiple
              size="small"
              limitTags={1}
              options={auctionsArray}
              disableCloseOnSelect
              onChange={(e, value, i, j) => {
                if (j) {
                  const hasOne = auArray.find(
                    (item2) => item2.value === j.option.value
                  );
                  if (hasOne) {
                    if (j.option.value === "ALL") {
                      onChangeAuctions([]);
                    } else {
                      auArray.map((item2, index2) => {
                        if (item2.value === j.option.value) {
                          auArray.splice(index2, 1);
                        }
                      });
                      onChangeAuctions(auArray);
                    }
                  } else {
                    if (j.option.value === "ALL") {
                      const newSelect = [];
                      for (let i = 0; i < auctionsArray.length; i++) {
                        newSelect.push(auctionsArray[i]);
                      }
                      const lastSelect = newSelect.filter(
                        (i) => i.value !== "應買"
                      );
                      onChangeAuctions(lastSelect);
                    } else {
                      auArray.push(j.option);
                      onChangeAuctions(auArray);
                    }
                  }
                } else {
                  onChangeAuctions([]);
                }
              }}
              value={auArray}
              getOptionLabel={(option) => option.label}
              getOptionSelected={(option, value) =>
                value && option.value === value.value
              }
              ListboxProps={{ style: { maxHeight: "14.5rem" } }}
              renderOption={(option) => {
                const selectFilmIndex = auArray.find(
                  (item) => item.value === option.value
                );
                return (
                  <React.Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={Boolean(selectFilmIndex)}
                    />
                    {option.label}
                  </React.Fragment>
                );
              }}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={2}
            classes={{ root: classes.DocumentContainerRow }}
          >
            <Checkbox
              color="primary"
              checked={respondBuy === "during"}
              onChange={() => {
                onChangeRespondBuy("during");
              }}
            />
            <Typography color="primary" style={{ fontSize: 15 }}>
              應買
            </Typography>
          </Grid>
          {inquiry && (
            <Grid item xs={4} sm={2}>
              <Typography style={{ color: "#FF9301", fontSize: 15 }}>
                排序
              </Typography>
              <Select
                items={latestArray}
                value={latest.value ? latest : null}
                onChange={(e, value) => {
                  if (value) {
                    onChangeLatest(value);
                  } else {
                    onChangeLatest();
                  }
                }}
                fullWidth
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
